import { ICompassusNavigatorRepository } from "../../adapters/driven/repositories/compassusNavigatorRepository";

export const CompassusNavigatorServiceImplFactory = ({
  compassusNavigatorRepository,
}: {
  compassusNavigatorRepository: ICompassusNavigatorRepository;
}) => {
  const getPatients: IGetCompassusPatients = async ({
    clinicId,
    queryParams,
  }) => {
    try {
      const response = await compassusNavigatorRepository.getPatientsAPI({
        clinic_id: clinicId,
        params: queryParams,
      });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as Error).message },
      };
    }
  };

  const getCounts: IGetCompassusCounts = async ({ clinicId, queryParams }) => {
    try {
      const response = await compassusNavigatorRepository.getCountsAPI({
        clinic_id: clinicId,
        params: queryParams,
      });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as Error).message },
      };
    }
  };

  const getPayerFilters: IGetCompassusPayerFilters = async ({ clinicId }) => {
    try {
      const response = await compassusNavigatorRepository.getPayerFiltersAPI({
        clinic_id: clinicId,
      });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const getMedicationFilters: IGetCompassusStringFilters = async ({
    clinicId,
  }) => {
    try {
      const response =
        await compassusNavigatorRepository.getMedicationFiltersAPI({
          clinic_id: clinicId,
        });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const getAllergyFilters: IGetCompassusStringFilters = async ({
    clinicId,
  }) => {
    try {
      const response = await compassusNavigatorRepository.getAllergyFiltersAPI({
        clinic_id: clinicId,
      });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const getConditionFilters: IGetCompassusStringFilters = async ({
    clinicId,
  }) => {
    try {
      const response =
        await compassusNavigatorRepository.getConditionFiltersAPI({
          clinic_id: clinicId,
        });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const getLastVisitProviderFilters: IGetCompassusStringFilters = async ({
    clinicId,
  }) => {
    try {
      const response =
        await compassusNavigatorRepository.getLastVisitProviderFiltersAPI({
          clinic_id: clinicId,
        });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const getNextVisitProviderFilters: IGetCompassusStringFilters = async ({
    clinicId,
  }) => {
    try {
      const response =
        await compassusNavigatorRepository.getNextVisitProviderFiltersAPI({
          clinic_id: clinicId,
        });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const getTodoTagFilters: IGetCompassusStringFilters = async ({
    clinicId,
  }) => {
    try {
      const response = await compassusNavigatorRepository.getTodoTagFiltersAPI({
        clinic_id: clinicId,
      });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const getClinicalRiskScoreFilters: IGetCompassusClinicalRiskScoreFilters =
    async ({ clinicId }) => {
      try {
        const response =
          await compassusNavigatorRepository.getClinicalRiskScoreFiltersAPI({
            clinic_id: clinicId,
          });
        return { success: true, data: response };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as Error).message },
        };
      }
    };

  const patchPatientTodo: IPatchCompassusPatientTodo = async ({
    clinicId,
    patientId,
    todoTags,
  }) => {
    try {
      const response = await compassusNavigatorRepository.patchPatientTodoAPI({
        clinic_id: clinicId,
        patient_id: patientId,
        body: { tags: todoTags },
      });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  const putWatchlist: IPutCompassusWatchlist = async ({ clinicId, items }) => {
    try {
      const response = await compassusNavigatorRepository.putWatchlistAPI({
        clinic_id: clinicId,
        body: { items },
      });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: { message: (error as Error).message } };
    }
  };

  return {
    getPatients,
    getCounts,
    getPayerFilters,
    getMedicationFilters,
    getAllergyFilters,
    getConditionFilters,
    getLastVisitProviderFilters,
    getNextVisitProviderFilters,
    getTodoTagFilters,
    getClinicalRiskScoreFilters,
    patchPatientTodo,
    putWatchlist,
  };
};
